import React from "react";

const Music = () => {
  const links = {
    es: "https://open.spotify.com/playlist/5siCegadnuLSFyfmrw9u0i?si=1f990912054f4ad1",
  };

  return (
    <a
      href={links.es}
      target="_blank"
      rel="noopener noreferrer"
      className="button-styles hover-text"
    >
      <span className="tooltip-text" id="fade">Music</span>
      <i className="bi bi-music-note-beamed"></i>
    </a>
  );
};

export default Music;